import { render, staticRenderFns } from "./Classificar.vue?vue&type=template&id=d18e388c"
import script from "./Classificar.vue?vue&type=script&lang=js"
export * from "./Classificar.vue?vue&type=script&lang=js"
import style0 from "./Classificar.vue?vue&type=style&index=0&id=d18e388c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports